import React, {Component} from 'react';
import {connect} from 'react-redux';
import MultistepSelect from '../multistep-select/MultistepSelect';
import {bindActionCreators} from 'redux';
import * as supplierCompetenciesActions from '../../actions/supplierCompetenciesActions';
import {toastr} from 'react-redux-toastr';
import * as submitButtonActions from '../../actions/submit/submitButtonActions';
import SupplierCompetenciesSubmit from "./SupplierCompetenciesSubmit";
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';
import SelectedItems from './SelectedItems';
import flattenNestedCategories from '../../selectors/flattenNestedCategoriesSelector';

export class SupplierCompetenciesContainer extends Component {

    componentDidMount() {
        this.props.actions.getSupplierCompetencies();

        this.props.actions.getSelectedCompetencies()
            .catch(() => toastr.error(this.props.intl.formatMessage(messages.supplierCompetenciesDontBelongToUser)));
    }

    /**
     * @param  {number} current            Current selected item id
     */
    onSelect(current) {
        this.props.actions.select(current);
    }

    onReset() {
        this.props.actions.deselect();
    }

    /**
     * Should be triggered when the user decided to
     * select some item itself even if it has child
     * items. On final selection child items normally
     * should be hidden.
     */
    onConfirm() {
        this.props.actions.add(this.props.current);
        this.props.actions.deselect();
    }

    onRemove(competency) {
        this.props.actions.remove(competency.id);
    }

    onSubmit() {
        this.props.actions.showSubmitButtonSpinner();
        this.props.actions.applySupplierCompetencies()
            .then(() => {
                this.props.actions.hideSubmitButtonSpinner();
                toastr.success(this.props.intl.formatMessage(messages.supplierCompetencies))
            })
            .catch(() => {
                this.props.actions.hideSubmitButtonSpinner();
                toastr.error(this.props.intl.formatMessage(messages.supplierCompetenciesUpdateError))
            });
    }

    render() {
        const {selection, current} = this.props;

        return (
            <div className="row">
                <div className="col-12">
                    <div className="card m-b-20">
                        <div className="card-block">
                            <h1 className="mb-3">{this.props.intl.formatMessage(messages.supplierCompetencies)}</h1>
                            <p>{this.props.intl.formatMessage(messages.supplierCompetenciesSelect)}</p>
                            <MultistepSelect
                                data={this.props.competencies}
                                selection={selection}
                                current={current}
                                onSelect={this.onSelect.bind(this)}
                                onConfirm={this.onConfirm.bind(this)}
                                onRemove={this.onRemove.bind(this)}
                                onReset={this.onReset.bind(this)}
                                selectedListComponent={SelectedItems}
                            />
                            <div className="form-group row mt-3">
                                <div className="col-sm-12">
                                    <SupplierCompetenciesSubmit isUpdate={true} onClick={this.onSubmit.bind(this)}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

const mapStateToProps = state => {
    return {
        competencies: state.supplierCompetencies.competencies,
        selection: state.supplierCompetencies.selected,
        current: state.supplierCompetencies.selectedOne
    };
};

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators(Object.assign({}, supplierCompetenciesActions, submitButtonActions), dispatch)
    };
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(SupplierCompetenciesContainer));


// WEBPACK FOOTER //
// ./web/src/components/supplier-competencies/SupplierCompetenciesContainer.jsx